import {partnerRfqDetail,behaviorActive,onboardingProgres,clientContact,quoteCompleteness} from "@/utils/api/zhenyunOrder"

export default {
data(){
  return{
    
  }
},
methods: {
  // 入参
    getParams(page) {
      let conditionParams = {};
      // 加入是query参数
      conditionParams = {
        subCategoryList: this.$route.query.category  //零件子工艺
          ? this.$route.query.category.split(",").map(val => Number(val))
          : [],
        materialList: this.$route.query.material   //零件材料
          ? this.$route.query.material.split(",").map(val => Number(val))
          : [],
        sizeTypeList: this.$route.query.partSize //零件尺寸类型
          ? this.$route.query.partSize.split(",").map(val => Number(val))
          : [],
        areaList: this.$route.query.region  //区域
          ? this.$route.query.region.split(",").map(val => Number(val))
          : [],
        clientSourceList:this.$route.query.orderSource //询盘来源 20-甄云
          ? this.$route.query.orderSource.split(",").map(val => Number(val))
          : [],
        paymentTermsList:this.$route.query.payWay //支付方式
          ? this.$route.query.payWay.split(",").map(val => Number(val))
          : [],  
        keyword: this.$route.query.keyword ? this.$route.query.keyword : "" ,//关键词
        curPage: page, 
        pageSize: 20,
        attribute:'', 
        sortType:0
      };
      return conditionParams
    },
    // 询盘详情接口处理
   async getRfqDetail(data){
    this.loading=true
     const res=await  partnerRfqDetail(data)
      if (res.rspResult.bizCode === 200) {
        this.detailsData=res.data
        // this.detailsData.quoteQuotaFull = 1
        this.loading=false
      }else{
        this.loading=false
        this.$message.error(res.rspResult.message);
      }
     
    },
    // 记录行为统计
    async recordBehaviorActive(compId){
      let params = {
        type : 1,
        compId : compId
      }
       try {
        const {data: {rspResult}} = await behaviorActive(params);
        if(rspResult.bizCode === 200) {
         
        } else {
          throw('出错了')
        }
      } catch(err) {
        console.log("System Error",err)
      }
    },
  
    // 获取入驻进度 甄云：20
    async getOnboarding(id){
      const params={
        channel:id || this.detailsData?.clientId
      }
      const res=await onboardingProgres(params)
      if(res.rspResult.bizCode==200){
        this.isSettledInfo=res.data
        // 手动填充一下signedAgreementTypeList属性以免调用.includes报错
        this.isSettledInfo = {
          ...this.isSettledInfo,
          signedAgreementTypeList: this.isSettledInfo?.signedAgreementTypeList || [],
        }
      }
    },
    // 专区联系人信息  根据询盘详情处理，目前只有甄云
    async getClientContact(clientId){
      const res=await clientContact(clientId)
      if(res.rspResult.bizCode==200){
        this.salesInfoClient=res.data
      }
    },
    // 伙伴供应商校验完成度 
    async getQuoteCompleteness(){
      const res=await quoteCompleteness()
      if(res.rspResult.bizCode==200){
        this.QuoteCompletenessData=res.data
      }
    },
}
}